/* 首页信息相关接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'


// 用户信息
export function getUserInfo () {
  return axios({
    url: path.mobile + '/service/getUserInfo',
    method: 'GET'
  })
}

// 获取跳转小程序链接
export function getUrlSchema () {
  return axios({
    url: path.mobile + '/service/getUrlSchema',
    method: 'GET'
  })
}


// 获取校园卡
export function getCampusCard () {
  return axios({
    url: path.mobile + '/service/getCampusCard',
    method: 'GET'
  })
}


// 轮播图
export function updateUser (data) {
  return axios({
    url: path.mobile + '/service/updateUser',
    data: data,
    method: 'PUT'
  })
}

